(() => {
  'use strict';
  const sizeRequests = new Map();

  if (!customElements.get('jb-ring-size-choice')) {
    customElements.define('jb-ring-size-choice', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.select = this.querySelector('select[data-jb-ring-size]');
        if (!this.select || !this.dataset.productId) return;
        const saved = sizeRequests.get(this.dataset.productId);
        if (saved && Array.from(this.select.options).some(option => option.value === saved)) this.select.value = saved;
        this.controller = new AbortController();
        this.addEventListener('change', event => {
          if (event.target !== this.select) return;
          event.stopPropagation();
          const value = this.select.value;
          sizeRequests.set(this.dataset.productId, value);
          document.querySelectorAll('jb-ring-size-choice').forEach(choice => {
            if (choice !== this && choice.dataset.productId === this.dataset.productId) {
              const select = choice.querySelector('select[data-jb-ring-size]');
              if (select && Array.from(select.options).some(option => option.value === value)) select.value = value;
            }
          });
          document.dispatchEvent(new CustomEvent('jb:ring-size-choice', {
            detail: { productId: this.dataset.productId, value }
          }));
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.('button.jb-request-price-button');
    if (!button) return;
    const info = button.closest('.product-information--inner, .product-information');
    const form = document.querySelector('#RequestPriceForm');
    if (!info || !form) return;
    const isRing = info.dataset.jbRingProduct === 'true';
    let value = isRing ? info.querySelector('select[data-jb-ring-size]')?.value || '' : '';
    if (isRing && !value) {
      const fieldset = Array.from(info.querySelectorAll('fieldset[data-index][data-handle]')).find(field => ['us','eu','diameter'].includes(field.dataset.jbRingSizeSystem) && !field.classList.contains('jb-ring-native-placeholder'));
      value = fieldset?.querySelector('select')?.value || fieldset?.querySelector('input:checked')?.value || '';
      if (value && /^\d+(?:[.,]\d+)?$/.test(value.trim())) {
        const system=fieldset.dataset.jbRingSizeSystem;
        if (system==='us') value = `US ${value}`;
        else if (system==='eu') value = `EU ${value}`;
        else if (system==='diameter') value = `${value} mm`;
      }
    }
    let field = form.querySelector('input[name="contact[Ring size]"]');
    if (!field && value) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'contact[Ring size]';
      form.append(field);
    }
    if (field) {
      field.value = value;
      field.disabled = !value;
    }
    const summary = form.querySelector('[data-jb-ring-size-summary]');
    if (summary) {
      summary.textContent = value ? summary.dataset.label + ' ' + value : '';
      summary.hidden = !value;
    }
  }, true);
})();
